module.exports = __webpack_public_path__ + "img/ch13.75229088.jpg";